import { FC } from 'react';
import { removeHtmlTagsFromString } from '../../../utils/StringUtils';
import { cn } from '../../../utils/classUtils';

interface ConfigDrivenSubtitleV2Props {
  subtitle: string;
  textStyle?: string;
}

const ConfigDrivenSubtitleV2: FC<ConfigDrivenSubtitleV2Props> = ({
  subtitle,
  textStyle,
}) => {
  return (
    <span
      className={cn(
        'font-inter font-normal text-base text-reskin-primary-dark',
        textStyle,
      )}
    >
      {removeHtmlTagsFromString(subtitle)}
    </span>
  );
};

export default ConfigDrivenSubtitleV2;
